/**
 * Helper functions for MVR (Motor Vehicle Record) related operations
 */

/**
 * Checks if there are MVR reports that need to be run
 * @param {Object} store - The MobX store containing offer data
 * @param {boolean} dirty - Whether the form is dirty
 * @param {Object} values - The form values object
 * @returns {Object} Object containing MVR check results
 */
export const getMVRCheckStatus = (store, dirty, values) => {
  const hasPostBindMVrs =
    !dirty &&
    values?.selectedOption &&
    values.selectedOption.includes('A') &&
    values?.drivers?.some((driver) => driver.postBindMVR);

  const hasMVRToRun = hasPostBindMVrs || store?.offer?.skippedDataPulls?.includes('drivers-violations');
  const hasOnlyMVRToRun = hasMVRToRun && store?.offer?.skippedDataPulls?.length === 1;
  const hasAtLeastMVRToPull = hasMVRToRun && store?.offer?.skippedDataPulls?.length > 1;

  return {
    hasMVRToRun,
    hasPostBindMVrs,
    hasOnlyMVRToRun,
    hasAtLeastMVRToPull
  };
};
